const dropotron = require("../assets/js/jquery.dropotron.min.js");

export default window.dropotron = dropotron;
